import PropTypes from "prop-types";

import useIntercomFeatureFlag from "./hooks/useIntercomFeatureFlag";

function IntercomProvider({ children }) {
  const { appId } = useIntercomFeatureFlag();

  return children(appId);
}

IntercomProvider.propTypes = {
  children: PropTypes.func.isRequired,
};

export default IntercomProvider;
